/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconInfoFilled/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconInfoFilled({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconInfoFilled",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "#323232",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconInfoFilled.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-1I0C0w': alignSelf,'--mt-2-1I0C0w': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1I0C0w': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1I0C0w': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1I0C0w': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1I0C0w': opacity,'--w-10-1I0C0w': typeof width === 'number' ? `${width}px` : width,'--h-11-1I0C0w': typeof height === 'number' ? `${height}px` : height,'--f-12-1I0C0w': fill,'--a-7-1I0C0w': isAnimated ? animation : "none",'--sd-8-1I0C0w': isAnimated ? strokeDashoffset : 0,'--sd-9-1I0C0w': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconInfoFilled.SvgPath"
  data-view-path={viewPath}
 d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
 className="views-block"
/>
</svg>
{children}
</React.Fragment>)
}